import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  NgModule,
  CUSTOM_ELEMENTS_SCHEMA,
  APP_INITIALIZER
} from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { PagesModule } from '@pages/pages.module';
import { SharedAppModule } from '@shared/shared-app.module';
import { ModalModule } from 'ngx-bootstrap';

import { AgmCoreModule } from '@agm/core';
import { StorageServiceModule } from 'angular-webstorage-service';
import { CurrentUserService } from '@shared/services';
import { PreOrderModule } from '@modules/pre-order/pre-order.module';
import { SignUpModule } from '@modules/sign-up/sign-up.module';
import { HttpClientModule } from '@angular/common/http';

export function currentUserProviderFactory(provider: CurrentUserService) {
  return () => provider.loanUserInfo();
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyBql65zCZClYO9iCAYo21TDF7dx9KTE4nk',
      libraries: ['places']
    }),
    PagesModule,
    SharedAppModule,
    AppRoutingModule,
    StorageServiceModule,
    ModalModule,
    PreOrderModule,
    SignUpModule,
    HttpClientModule
  ],
  providers: [
    CurrentUserService,
    {
      provide: APP_INITIALIZER,
      useFactory: currentUserProviderFactory,
      deps: [CurrentUserService],
      multi: true
    },
    Title
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {}
